import { createSelector } from 'reselect';

export const selectCurrentUser = state => state.currentUser.data;
export const selectCurrentUserId = createSelector(selectCurrentUser, user => user.id);

export default { selectCurrentUser, selectCurrentUserId };
